import React from "react";
import { CardListingHeader } from "./style";
import { FilterIcon } from "../../shared/icons";

interface Props {
  headingTitle: string;
  onFilterClick?: () => void;
}

const CardListHeader: React.FC<Props> = ({ headingTitle, onFilterClick }) => {
  return (
    <CardListingHeader>
      <div>
        <h4>{headingTitle}</h4>
        <div onClick={onFilterClick}>
          <img src={FilterIcon} alt="Filter_icon" />
          <span>Filter</span>
        </div>
      </div>
    </CardListingHeader>
  );
};

export default CardListHeader;
